import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { IGlobal } from "config/config.interface";
import ProfileService from "../../../../../features/participant-experience/profile/profile.service";
import { changeAssessmentLanguage } from "lib/reducers/user.slice";

export default function LanguagePicker() {
    const globalConfig = (global as any as IGlobal);
    const user = useAppSelector(state => state.user);
    const dispatch = useAppDispatch();
    const profileService = new ProfileService(user);

    const handleChangeAssessmentLanguage = (id: number) => {
        profileService.UpdateLanguage(user.participantId, id)
            .subscribe({
                next: () => {
                    dispatch(changeAssessmentLanguage({id}));
                }
            })
    }


    return (
        <>
            <UncontrolledDropdown>
                <DropdownToggle className="p-0 mr-2 nav-link" color="link" style={{ color: 'gray' }} >
                    <div className="language-icon" style={{ fontSize: '0.88rem' }}>
                        <div style={{ fontWeight: 'bold' }}>{globalConfig.config.LANGUAGES[user.participantLanguageId].name1}</div>
                    </div>
                    <FontAwesomeIcon className="ml-2 opacity-8" icon={faAngleDown} style={{ marginTop: 1 }} />
                </DropdownToggle>

                <DropdownMenu className="rm-pointers" style={{ minWidth: '8rem' }}>
                    <div className="dropdown-menu-header">
                        <div className="dropdown-menu-header-inner pt-2 pb-2 bg-focus">
                            <div className="menu-header-content text-center text-white">
                                <h6 className="menu-header-subtitle mt-0 text-white " style={{ fontWeight: 'bold' }}>Choose Your Language</h6>
                            </div>
                        </div>
                    </div>

                    {
                        globalConfig.config.LANGUAGES.map((language, index) => {
                            if (index === 0) return null;
                            return (
                                <DropdownItem key={index}
                                    active={(index === user.participantLanguageId) ? true : false}
                                    style={{ paddingTop: 2, paddingBottom: 2 }}
                                    onClick={() => handleChangeAssessmentLanguage(index)}
                                >
                                    {language.name1}
                                </DropdownItem>
                            );
                        })
                    }

                </DropdownMenu>
            </UncontrolledDropdown>
        </>
    )
}